export const createCrosshairPlugin = (cursorPositionRef) => ({
  id: "crosshairPlugin",
  afterDraw: (chart) => {
    const ctx = chart.ctx;
    const xScale = chart.scales.x;
    const scales = chart.scales;

    if (cursorPositionRef.current.index != null) {
      const index = cursorPositionRef.current.index;

      // The x value is the data index (numeric axis, or a category's index)
      const x = xScale.getPixelForValue(index);

      if (x >= xScale.left && x <= xScale.right) {
        ctx.save();
        ctx.strokeStyle = "rgba(0, 0, 0, 0.5)";
        ctx.lineWidth = 1;

        // Draw vertical line
        ctx.beginPath();
        ctx.moveTo(x, chart.chartArea.top);
        ctx.lineTo(x, chart.chartArea.bottom);
        ctx.stroke();

        // Draw horizontal line only on the current chart
        if (
          cursorPositionRef.current.currentChartId === chart.id &&
          cursorPositionRef.current.y != null
        ) {
          const y = cursorPositionRef.current.y;

          if (y >= chart.chartArea.top && y <= chart.chartArea.bottom) {
            // Draw horizontal line
            ctx.beginPath();
            ctx.moveTo(chart.chartArea.left, y);
            ctx.lineTo(chart.chartArea.right, y);
            ctx.stroke();
          }
        }

        // Collect data points at the current index
        const dataPoints = [];

        chart.data.datasets.forEach((dataset) => {
          const dataPoint = dataset.data[index];
          const yValue = dataPoint !== null && typeof dataPoint === 'object' ? dataPoint.y : dataPoint;
          if (yValue == null || isNaN(yValue)) {
            return; // Skip if data is missing
          }

          const yAxisID = dataset.yAxisID || 'y';
          const yScale = scales[yAxisID];
          if (!yScale) return;

          // Get y pixel for data point
          const yPixel = yScale.getPixelForValue(yValue);

          dataPoints.push({
            yValue,
            yPixel,
            color: dataset.borderColor || 'black',
            label: dataset.label || '',
          });
        });

        // Adjust text position based on x position
        const labelFontSize = 12;
        const labelPadding = 5;
        let textX = x + 5; // Default to right of the line
        ctx.textAlign = 'left';

        if (x + 100 > chart.chartArea.right) {
          // If too close to the right edge, render to the left
          textX = x - 5;
          ctx.textAlign = 'right';
        }

        // Start textY from top of the chart area
        let textY = chart.chartArea.top + labelPadding + labelFontSize / 2;

        // Render data labels
        dataPoints.forEach((dataPoint) => {
          const { yValue, color, label } = dataPoint;

          ctx.fillStyle = chart.options.dataLabelColor || color;
          ctx.font = `${labelFontSize}px Arial`;
          ctx.textBaseline = 'middle';

          const valueText = `${label}: ${yValue.toFixed(2)}`;

          ctx.fillText(valueText, textX, textY);

          textY += labelFontSize + labelPadding;

          // Prevent text from going beyond the chart area
          if (textY > chart.chartArea.bottom - labelFontSize) {
            textY = chart.chartArea.bottom - labelFontSize;
          }
        });

        ctx.restore();
      }
    }
  },
});
